export const projects = [
  {
    product: 'Indicina',
    link: 'https://indicina.co'
  },
  {
    product: 'KongaPay Merchant Portal',
    link: 'https://business.kongapay.com'
  },
  {
    product: 'KongaPay Agency Network',
    link: '"https://agency.kongapay.com"'
  },
  {
    product: 'More',
    link: 'https://www.linkedin.com/in/godspower-osilama/details/projects/'
  }
];

export const testimonials = [
  {
    quote:
      "God'spower is a very talented software developer. He doesn't shy away from complex problems and is always working to improve his craft. He is adaptable and a lifelong learner, and he is also very fun to work with.",
    image: "./ladi.jpeg",
    name: "Oladipupo Bello",
    company: "Glovo",
  },
  {
    quote:
      "Godspower is hardworking and dedicated. He loves algorithms and enjoys the art of writing code. He is confident and approaches problem by first trying to understand the issue at hand before proceeding with a solution. He is smart and fun to work with. ",
    image: "./jacob.jpeg",
    name: "Jacob Ayokunle",
    company: "indicina.co",
  },
  {
    quote:
      "I am lucky to have worked with God'spower. His dedication to work is really astounding. I remember when God'spower joined the KongaPay team and was given a task to build a mobile SDK for payment on Android and iOS platforms. Not minding the fact he has little knowledge of this, he went above and beyond to ensure he achieved this. \n" +
        "Picking up new technologies and aligning them to improve and benefit the business is another area in which God'spower excels. Today, he owns and manages a lot of KongaPay's core services both backend and mobile. He is going to be a great addition to any team in which he finds himself",
    image: "./kay.jpeg",
    name: "Kayode Oguntimehin",
    company: "Wayfair",
  },
  {
    quote:
      "I have seen God'spower going above and beyond to achieve tasks. He always try new challenges and doesn't limit himself to his comfort zone.",
    image: "./razaq.jpeg",
    name: "Razaq Kasali",
    company: "Deimos",
  },
];

export const skills = [
  "JavaScript",
    "TypeScript",
  "Node",
    "Go",
  "React",
  "NestJS",
  "GraphQL",
  "Springboot",
    "AWS",
    "K8S",
    "Docker"
];



// WEBPACK FOOTER //
// ./src/data.js